/**
 * PlanSelector Component
 * 
 * Seletor de planos de assinatura
 * - Exibe 3 planos (Free, Básico, Premium)
 * - Grid responsivo
 * - Destaque de plano atual
 * 
 * Fase 5 - UI de Pagamentos
 */

import { PlanCard } from './PlanCard';
import { useSubscription } from '../../hooks/useSubscription';

interface PlanSelectorProps {
  billingCycle: 'monthly' | 'semester' | 'annual';
  onSelectPlan: (plan: 'free' | 'basic' | 'premium') => void;
}

export function PlanSelector({ billingCycle, onSelectPlan }: PlanSelectorProps) {
  const { subscription } = useSubscription();

  // Preços conforme o ciclo
  const prices = {
    free: 0,
    basic: {
      monthly: 990, // R$ 9,90
      semester: 5400, // R$ 54,00
      annual: 9900 // R$ 99,00
    },
    premium: {
      monthly: 1490, // R$ 14,90
      semester: 8128, // R$ 81,28
      annual: 14900 // R$ 149,00
    }
  };

  // Features de cada plano
  const planFeatures = {
    free: [
      '3 membros na família',
      '3 consultas SOS',
      'Análise de prescrição (30 dias)',
      'Alertas de horários das medicação',
      'Sistema de medicação completa',
      'Histórico ilimitado'
    ],
    basic: [
      '5 membros na família',
      '3 consultas SOS/mês',
      'Análise de prescrição ilimitado',
      'Alertas de horários das medicação',
      'Sistema de medicação completa',
      'Histórico ilimitado',
      'Suporte por e-mail'
    ],
    premium: [
      '10 membros na família',
      'Consultas SOS ilimitados',
      'Análise de prescrição ilimitado',
      'Alertas de horários das medicação',
      'Sistema de medicação completa',
      'Histórico ilimitado',
      'Suporte prioritário'
    ]
  };

  const currentPlan = subscription?.plan_tier || 'free';

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 px-4 max-w-7xl mx-auto">
      {/* Plano FREE */}
      <PlanCard
        plan="free"
        price={prices.free}
        billingCycle={billingCycle}
        features={planFeatures.free}
        isCurrentPlan={currentPlan === 'free'}
        onSelect={() => onSelectPlan('free')}
      />

      {/* Plano BÁSICO */}
      <PlanCard
        plan="basic"
        price={prices.basic[billingCycle]}
        billingCycle={billingCycle}
        features={planFeatures.basic}
        isCurrentPlan={currentPlan === 'basic'}
        isRecommended
        onSelect={() => onSelectPlan('basic')}
      />

      {/* Plano PREMIUM */}
      <PlanCard
        plan="premium"
        price={prices.premium[billingCycle]}
        billingCycle={billingCycle}
        features={planFeatures.premium}
        isCurrentPlan={currentPlan === 'premium'}
        onSelect={() => onSelectPlan('premium')}
      />
    </div>
  );
}
